import { render, staticRenderFns } from "./NonPartnerBadge.vue?vue&type=template&id=f62fad70&scoped=true&"
import script from "./NonPartnerBadge.vue?vue&type=script&lang=js&"
export * from "./NonPartnerBadge.vue?vue&type=script&lang=js&"
import style0 from "./NonPartnerBadge.vue?vue&type=style&index=0&id=f62fad70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62fad70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VTooltip})
